import { ChangeEvent, Component, InputHTMLAttributes, Ref } from 'react';
import cn from 'classnames';
import styles from './input.scss';
import Icon from 'components/Shared/Icon';
import { ToolTip } from 'components/Shared/ToolTip';
import { Unit } from './unit';

export type OnChangeHandler = (e: ChangeEvent<HTMLInputElement>, newValue?: string) => void;

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  innerRef?: Ref<HTMLInputElement>;
  invalid?: boolean;
  valid?: boolean;
  className?: string;
  unit?: string;
  onChange: OnChangeHandler;
  classNames?: {
    inputField?: string;
  };
}

export class Input extends Component<InputProps> {
  public render() {
    const {
      innerRef,
      invalid,
      valid,
      className,
      type = 'text',
      onChange,
      classNames = {},
      maxLength,
      ...rest
    } = this.props;

    return (
      <div className={cn(styles.input, className)}>
        <input
          ref={innerRef}
          type={type}
          className={cn(styles.inputField, classNames.inputField, {
            [styles.invalid]: invalid,
            [styles.valid]: valid
          })}
          onChange={this.handleChange}
          {...rest}
        />
        {invalid && (
          <Icon icon="icon-warning" inline className={cn(styles.inputIcon, styles.invalid)} />
        )}
        {valid && (
          <Icon
            icon="icon-check"
            inline
            size="small"
            className={cn(styles.inputIcon, styles.valid)}
          />
        )}
        {this.props.unit && <Unit unit={this.props.unit} value={this.props.value} />}
      </div>
    );
  }

  private handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.currentTarget.value;
    this.props.onChange(e, newValue);
  };
}

interface Props extends InputProps {
  label?: string;
  tooltip?: string;
}

export const LabeledInput = ({ className, label, tooltip, ...input }: Props) => (
  <div className={cn(styles.labelInput, className)}>
    {(label || tooltip) && (
      <span>
        {label && <label>{label}</label>}
        {tooltip && <ToolTip className={styles.tooltip} text={tooltip} />}
      </span>
    )}
    <Input {...input} />
  </div>
);
